import { callsQueryParams } from "./callsQueryParams.svelte";

class BaseCallsQuery {
  #data = $state([]);

  data = $derived.by(() => {
    const { order, columns } = this.params;

    // If no ordering is specified, return the data as is
    if (!order || !order.length) return this.#data;

    // Get the column definition to use for sorting
    const column = columns[order[0].column];
    const ascending = order[0].dir === "asc";

    // Function to get value from row based on column definition
    const getValue = (row, col) => {
      if (typeof col.data === "string") {
        return row[col.data];
      }
      return col.data(row);
    };

    // Datatables uses render function to sort data with type arg of "sort"
    const { render = (x) => x } = column;

    return [...this.#data].sort((row1, row2) => {
      const v1 = render(getValue(row1, column), "sort");
      const v2 = render(getValue(row2, column), "sort");

      if (v1 === v2) {
        return 0;
      }

      const ret = v1 < v2 ? -1 : 1;
      return ascending ? ret : -ret;
    });
  });

  recordsTotal = $state(0);

  recordsFiltered = $state(0);

  draw = $state(0);

  constructor({ params, queryStore }) {
    this.params = params;

    queryStore.subscribe((resp) => {
      this.#data = resp.data || [];
      this.recordsTotal = resp.recordsTotal || 0;
      this.recordsFiltered = resp.recordsFiltered || 0;
      this.draw = resp.draw || 1;
    });

    $effect.root(() => {
      $effect(() => {
        if (this.data.length === 0 && this.recordsTotal > this.#data.length) {
          this.params.reset(true);
        }
      });
    });
  }
}

export const getCallsQuery = (queryStore) =>
  new BaseCallsQuery({
    params: callsQueryParams,
    queryStore,
  });
